import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-crlv',
  templateUrl: './consulta-crlv.component.html',
  styleUrls: ['./consulta-crlv.component.scss']
})
export class ConsultaCrlvComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  @Input() token = '';

  constructor() {}

  ngOnInit() {}

  ngOnChanges() {}

}
